import { __extends } from "tslib";
import * as React from 'react';
import { classNames } from '@wix/answers-lib';
import { namespacedClassnames } from '../../../common';
import { SmallToggleArrowIcon } from '../../../icons/icons-components';
export var scrollableBarInnerKey = 'scrollable-bar-inner';
export var scrollButtonKey = 'scroll-button';
var ScrollableBarInner = /** @class */ (function (_super) {
    __extends(ScrollableBarInner, _super);
    function ScrollableBarInner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showLeft: false,
            showRight: false
        };
        _this.scrollable = React.createRef();
        _this.scrollChanged = function (e) {
            var contentSize = _this.props.contentSize;
            var viewportWidth = _this.props.viewportWidth;
            viewportWidth = viewportWidth || _this.scrollable.current && _this.scrollable.current.clientWidth || 0;
            var newOffset = (e && e.target.scrollLeft)
                || (_this.scrollable.current && _this.scrollable.current.scrollLeft)
                || 0;
            _this.setState({
                showLeft: Boolean(newOffset !== 0),
                showRight: Boolean(newOffset + viewportWidth < contentSize)
            });
        };
        _this.scrollRight = function () {
            if (_this.scrollable.current) {
                var viewportWidth = _this.props.viewportWidth;
                viewportWidth = viewportWidth || _this.scrollable.current.clientWidth;
                var current = _this.scrollable.current.scrollLeft;
                _this.scrollable.current.scroll({ left: current + viewportWidth, behavior: 'smooth' });
            }
        };
        _this.scrollLeft = function () {
            if (_this.scrollable.current) {
                var viewportWidth = _this.props.viewportWidth;
                viewportWidth = viewportWidth || _this.scrollable.current.clientWidth;
                var current = _this.scrollable.current.scrollLeft;
                _this.scrollable.current.scroll({ left: current - viewportWidth, behavior: 'smooth' });
            }
        };
        return _this;
    }
    ScrollableBarInner.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () { return _this.scrollChanged(); }, 400);
    };
    ScrollableBarInner.prototype.componentWillReceiveProps = function () {
        var _this = this;
        setTimeout(function () { return _this.scrollChanged(); }, 200);
    };
    ScrollableBarInner.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var leftClassName = classNames(scrollButtonKey, "left-" + scrollButtonKey, state.showLeft ? 'fade-in' : 'fade-out');
        var rightClassName = classNames(scrollButtonKey, "right-" + scrollButtonKey, state.showRight ? 'fade-in' : 'fade-out');
        return (React.createElement("div", { className: namespacedClassnames(scrollableBarInnerKey, props.className), style: { width: '100%' } },
            React.createElement("button", { className: leftClassName, onClick: this.scrollLeft, disabled: !state.showLeft },
                React.createElement(SmallToggleArrowIcon, null)),
            React.createElement("div", { className: 'scrollable', onWheel: this.scrollChanged, onScroll: this.scrollChanged, ref: this.scrollable },
                React.createElement("div", { className: 'scroller-children-container', style: { width: props.contentSize } }, props.children)),
            React.createElement("button", { className: rightClassName, onClick: this.scrollRight, disabled: !state.showRight },
                React.createElement(SmallToggleArrowIcon, null))));
    };
    return ScrollableBarInner;
}(React.PureComponent));
export { ScrollableBarInner };
//# sourceMappingURL=index.js.map